import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { AcrType } from "@type/HRM/acr";

const { EMPLOYEES } = URLS;

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${EMPLOYEES}`;

export const createACR = (() => {
  return async (data: { data: AcrType }): Promise<{ data: AcrType }> => {
    const { employeeID, ...rest } = data.data;

    return api
      .post(`${apiEndPoint}/${employeeID}/acr`, { ...rest })
      .then((response) => ({ data: response.data }));
  };
})();

export const getACRHistory = (() => {
  return async (employeeID: string): Promise<{ data: AcrType }> => {
    return api
      .get(`${apiEndPoint}/${employeeID}/acr`)
      .then((response) => ({ data: response.data.employeeAcrList }));
  };
})();

export const deleteACRHistory = (() => {
  return async (data: { data: AcrType }): Promise<{ data: AcrType }> => {
    const { acrID, employeeID } = data.data;

    return api
      .delete(`${apiEndPoint}/${employeeID}/acr/${acrID}`)
      .then((response) => {
        return { data: acrID };
      });
  };
})();
